export type ContentNotFoundErrorOptions = {
	readonly message?: string;
};

export class ContentNotFoundError extends Error {
	public readonly value?: unknown;

	public constructor({ message }: ContentNotFoundErrorOptions) {
		super(message ?? 'Content not found');
		this.name = ContentNotFoundError.name;
	}
}

export const isContentNotFoundError = (error: unknown): error is ContentNotFoundError => {
	return error instanceof ContentNotFoundError;
};

export const isRelayError = (error: unknown): boolean => {
	if (!error) return false;
	const errorObj = error as Error;
	return !!(
		(errorObj.name && errorObj.name.includes('RelayNetwork')) ||
		(errorObj.message && errorObj.message.includes('Relay'))
	);
};

// Function names that indicate content/GraphQL operations.
const CONTENT_FUNCTION_PATTERNS = [
	'fetchResponse', // Relay environment fetches
	'fetchOperation', // urql fetches
	'AGGClient.query', // AGG client fetches
];

export const isContentFetchError = (error: unknown): boolean => {
	if (!(error instanceof Error)) {
		return false;
	}

	// Check if it's a fetch error
	const hasFetchErrorMessage =
		error.message.includes('Failed to fetch') ||
		error.message.includes('Load failed') ||
		error.message.includes('[Network]'); // urql network error.

	if (!hasFetchErrorMessage) {
		return false;
	}

	// If there's no stack trace, we can't verify the context
	if (!error.stack) {
		return false;
	}

	// Check if the stack trace contains content-related function calls
	return CONTENT_FUNCTION_PATTERNS.some((pattern) => error.stack?.includes(pattern));
};
